import { PlayerFilterDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showPlayerFilterDialog = mountDialogUIReactComponent(PlayerFilterDialog);
